import './index.css'
import Button from '../button'
import TagGradient from '../tag-gradient';
import { useState } from 'react';

function SubpageHero({headline,tag,desc,img}){
    const navigateToLoginPage = () => {
        window.location.href = '/signup';
    }

    const navigateToPricing = () => {
        document.getElementById("pricing-holder").scrollIntoView({
            behavior: 'smooth', // Defines the scrolling behavior
            block: 'start', // Aligns the element at the start of the scrollable area (can be 'start', 'center', 'end', or 'nearest')
            inline: 'nearest' // Aligns the element horizontally (can be 'start', 'center', 'end', or 'nearest')
        });
        
    }

    return (
        <div className='subpage-abovefold-holder'>
        <div className='subpage-hero-content'>

        <TagGradient text={tag} />
        <h1 className='big-text homepage-title'>{headline}</h1>
        <p className='small-text description-of-service'>{desc}</p>
        <div className='cta-bar'>
        <Button addedFunction={navigateToLoginPage} text='Start 14 day free trial'></Button>
        <Button text='Pricing' addedFunction={navigateToPricing}></Button>
        </div>
            </div>
        <img className='subpage-image' src={img} />
        </div>
)
}

export default SubpageHero